import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'

import { Link } from 'gatsby'

class CloudHosting extends React.Component {

    shouldComponentUpdate() {
        return false
    }
      
    render() {

        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #111;
            padding: 10px 0 50px 0;
            .heading {
                width: 100%;
            }
            @media (max-width: 767px) {
                padding: 10px 0 50px 0;           
            }
        `

        const ServiceRow = styled(Row)`
            margin-top: 100px;
        `

        const ServiceHeading = styled.h3`
            font-size: 28px;
            font-weight: 500;
            font-family: Teko;
            color: #fff;
            margin-bottom: 0px;
            margin-top: 50px;
        `

        const Heading3a = styled.h3`
            font-size: 50px;
            font-family: Poppins;
            color: #fff;
            line-height: 50px;
            text-align: center;                    
        ` 

        const ServiceHeadinga = styled(Link)`
            font-family: Oswald;
            color: #fff;
            transition: .5s;
            &:hover {
              color: #c1eb18;
              text-decoration: none;
            }
        `

        const ServiceSeparator = styled.div`
            height: 2px;
            width: 50px;
            background-color: #c1eb18;
            margin-bottom: 5px;
         `

         const ServiceNumber = styled.p`
            position: absolute;
            font-size: 60px;
            color: #fff;
            font-weight: 900;
            top: -80px;
            opacity: .1;            
            transition: .2s;
         `

         const ServiceElement = styled.div`
            margin-bottom: 90px;
            border-radius: 20px;
            transition: .2s;
            position: relative;
            &:hover ${ServiceNumber} {
                opacity: .3 !important;
                color: #c1eb18;
            }
        `
         
         const ServiceText = styled.p`
            font-size: 16px;
            font-weight: 300;
            color: #c5c5c5;
            padding-right: 25px;            
         `

         const ServicePrecio = styled.p`
            font-size: 30px;
            font-weight: 300;
            color: #A3FF00;
            padding-right: 25px;
            @media (min-width:768px) and (max-width:1024px) {
                font-size: 20px;            
         `

         const ServiceDesde = styled.sup`
            position: relative;            
            vertical-align: baseline;
            top: -.3em;            
            font-family: 'Poppins';
            line-height: 26px;
            font-size: 14px;
            color: #fff;
            font-style: italic;
            font-weight: lighter;
         `

         const Textg = styled.p`
            position: relative;            
            vertical-align: baseline;
            top: -.3em;            
            font-family: 'Poppins';
            text-align: center;
            line-height: 26px;
            font-size: 14px;
            color: #fff;
            font-style: italic;
            font-weight: lighter;
            padding-bottom: 80px;
            margin-top: 10px;
            @media (max-width: 767px) {
                margin-top: 30px;          
            }
         `
         
         const { data } = this.props;
        // Agregar verificación para asegurarse de que los datos están disponibles
        if (!data || !data.allPricesJson || !data.allPricesJson.nodes.length) {
            return <div>Loading...</div>;
        }
        
        const prices = data.allPricesJson.nodes[0].items;

        console.log(prices)

        return(
            <Section>
                <Container>
                    <ServiceRow>
                        <Col md={3}>
                            
                                <ServiceElement>
                                    <ServiceNumber>
                                        05
                                    </ServiceNumber>
                                    <ServiceHeading>
                                        <ServiceHeadinga to="/cloud-wordpress-hosting">
                                            Cloud WordPress
                                        </ServiceHeadinga>
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        2 sitios WordPress<br></br>Balanceador de carga<br></br>Almacenamiento Ceph
                                    </ServiceText>
                                    <ServiceDesde>
                                        Desde
                                    </ServiceDesde>
                                    <ServicePrecio>
                                        ${prices.find(x => x.name === 'Wordpress').price}/mes
                                    </ServicePrecio>
                                </ServiceElement>
                            
                        </Col>
                        <Col md={3}>
                            
                                <ServiceElement>
                                    <ServiceNumber>
                                        06
                                    </ServiceNumber>
                                    <ServiceHeading>
                                        <ServiceHeadinga to="/cloud">
                                            Cloud
                                        </ServiceHeadinga>
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        AWS, DigitalOcean o Google<br></br>WordPress, WooCommerce, PHP, laravel o Magento
                                    </ServiceText>
                                    <ServiceDesde>
                                        Desde
                                    </ServiceDesde>
                                    <ServicePrecio>
                                        ${prices.find(x => x.name === 'Cloud').price}USD/mes
                                    </ServicePrecio>
                                </ServiceElement>
                            
                        </Col>
                        <Col md={3}>
                            
                                <ServiceElement>
                                    <ServiceNumber>
                                        07
                                    </ServiceNumber>
                                    <ServiceHeading>
                                        <ServiceHeadinga to="vps-kvm">
                                            VPS KVM
                                        </ServiceHeadinga>
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        CentOS, Debian y Ubuntu<br></br>Discos SSD y HDD<br></br>SIN Administrar
                                    </ServiceText>
                                    <ServiceDesde>
                                        Desde
                                    </ServiceDesde>
                                    <ServicePrecio>
                                        ${prices.find(x => x.name === 'KVM').price}/mes
                                    </ServicePrecio>
                                </ServiceElement>
                            
                        </Col>
                        <Col md={3}>
                            
                                <ServiceElement>
                                    <ServiceNumber>
                                        08
                                    </ServiceNumber>
                                    <ServiceHeading>
                                        <ServiceHeadinga to="/vps-administrado">
                                            VPS Administrado
                                        </ServiceHeadinga>
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        Tecnología NVME<br></br>Discos SSD<br></br>100% Administrado
                                    </ServiceText>
                                    <ServiceDesde>
                                        Desde
                                    </ServiceDesde>
                                    <ServicePrecio>
                                        ${prices.find(x => x.name === 'Admin').price}/mes
                                    </ServicePrecio>
                                </ServiceElement>
                            
                        </Col>
                    </ServiceRow>
                    <Row>
                        <Col md={12}>
                            <Heading3a>Garantía de reembolso por 30 días</Heading3a>
                            <Textg>
                                * Aplica solo para los servicios o planes de Hosting Colombia, Hosting cPanel y Certificados SSL. Aplican Términos y Condiciones
                            </Textg>
                        </Col>
                    </Row>
                </Container>
            </Section>
        )
    }

}

export const query = graphql`
  query {
    allPricesJson(filter: { page: { eq: "inicio" }, section: { eq: "planes" } }) {
      nodes {
        items {
          name
          price
        }
      }
    }    
  }
`

const Iconos = (props) => (
    <StaticQuery
      query={query}
      render={(data) => (
        <CloudHosting
          data={data}
        />
      )}
    />
  )
  
  export default Iconos;